import app from "@/common/plugins/vueInstance";
import VCalendar from "v-calendar";
import "v-calendar/dist/style.css";

app.use(VCalendar, {});
